export class Contato {
  id: Number = 0;
  id_condominio: Number = 0;
  tipo: any;
  contato: String = "";
  morador: Number = 0;
}
